import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { FlexCol } from "src/utils/flexLayouts";
import {
    myTasksIncidentsRecipientsListListName,
    myTasksIncidentstListName,
    myTasksTypeIncidentsListName,
} from "src/api/config/myTasksInc.config";
import {
    myTasks5WayListName,
    myTasksSDCA5WayListName,
} from "src/api/config/myTasks5Way.config";
import ChartLicense from "src/pages/DashboardPage/gos/components/chart-license/chart-license";
import { Modal } from "src/components/DialogComponent";
import { emailsSender, siteUrl } from "src/api/config";
import {
    downloadOutlookEmailWithAttachments,
    getRandomColor,
    urlDefault,
} from "src/constants";
import { emailAPI } from "src/utils/api.utils";
import html2canvas from "html2canvas";
import {
    actionsStatus,
    incStatus,
    incTypes,
    isStrapi,
} from "src/api/config/systemSwitch";
import { selectCurrentUser } from "src/modules/users/selector";
import { useLocation, useNavigate } from "react-router-dom";
const { sendEmail } = emailAPI();



export default function IncidentsReportFromEmail(props: any) {
    const typesIncList: any = useAppSelector((state) =>
        selectItems(state, myTasksTypeIncidentsListName)
    );
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [typesInc, setTypesInc] = useState<any>([]);
    const [openSendReportModal, setOpenSendReportModal] = useState(true);
    const [formDataSendEmails, setFormDataSetEmails] = useState<any>(null);
    const [fieldsSendEmails, setFieldsSetEmails] = useState<any>([
        {
            type: "dateRange",
            require: true,
            key: "DateIncidents",
            title: "Дата регистрации",
            placeholder: "дд.мм.гггг",
            width: "w-full",
        },
        {
            type: "radio",
            require: true,
            title: "Тип инцидента",
            key: "TypeIncident",
            width: "w-full",
        },
        // {
        //     type: "radio",
        //     require: true,
        //     title: "Скачать в .eml",
        //     key: "Msg",
        //     width: "w-full",
        //     optionsInputs: ["Да", "Нет"],
        // },
    ]);
    const [loadingSendEmail, setLoadingSetEmail] = useState(false);
    const [tempScreenData, setTempScreenData] = useState<any>({});
    const [tempScrenLabels, setTempScrenLabels] = useState<any>([]);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (typesIncList.length > 0) {
            setTypesInc(
                typesIncList.filter((type: any) => type.ID !== incTypes.security)
            );
        }
    }, [typesIncList]);

    useEffect(() => {
        const tempFieldsForm: any = [...fieldsSendEmails];
        for (let i = 0; i < tempFieldsForm.length; i++) {
            if (tempFieldsForm[i]["key"] === "TypeIncident") {
                tempFieldsForm[i]["optionsInputs"] =
                    typesInc.map((type: any) => type.Title.trim()) || [];
            }
        }
        setFieldsSetEmails([...tempFieldsForm]);
    }, [typesInc]);

    useEffect(() => {
        if (formDataSendEmails && Object.keys(formDataSendEmails).length > 0) {
            setTempScreenData({});
            setTempScrenLabels([]);
            setLoadingSetEmail(true);
            let filterIncEmails: any = { Questions: [`"IncidentOption":"Инцидент"`] },
                idCurrentTypeInc: any,
                localIncDateEmails: any;
            Object.keys(formDataSendEmails).map((key) => {
                if (key === "DateIncidents") {
                    localIncDateEmails = {
                        start: moment(formDataSendEmails[key].startDate).startOf('day').unix(),
                        end: moment(formDataSendEmails[key].endDate).endOf('day').unix(),
                        endDate: moment(formDataSendEmails[key].endDate),
                    };
                    // filterIncEmails[key] = {
                    //     start: moment(formDataSendEmails[key].startDate).startOf('day').format('YYYY-MM-DDT00:00:00'),
                    //     end: moment(formDataSendEmails[key].endDate).endOf('day').format('YYYY-MM-DDT23:59:59'),
                    // }
                } else if (key === "TypeIncident") {
                    idCurrentTypeInc = typesInc.filter(
                        (type: any) => type.Title === formDataSendEmails[key]
                    )[0]["ID"];
                    filterIncEmails[key] = idCurrentTypeInc;
                }
            });
            getItemsRequest({
                listName: myTasksIncidentstListName,
                filters: filterIncEmails,
                sortOrder: { name: "DateIncidents", desc: true },
            }).then((results: any) => {
                const { items } = results;
                let incIds: string[] = [];
                let requests5Way: any = [];
                items.map((item: any) => {
                    requests5Way = [
                        ...requests5Way,
                        getItemsRequest({
                            listName: myTasks5WayListName,
                            filters: { Incident: item.ID },
                        }),
                    ];
                });
                Promise.all(requests5Way).then((values: any) => {
                    let cards5Way: any = [],
                        deviationCardsIds: any = [];
                    values.map((results: any) => {
                        cards5Way = [...cards5Way, ...results["items"]];
                    });
                    cards5Way
                        .filter((card5Way: any) => card5Way.Type5Way === "DeviationReport")
                        .map((card5Way: any) => {
                            deviationCardsIds = [...deviationCardsIds, card5Way.ID];
                        });
                    Promise.all([
                        getItemsRequest({
                            listName: myTasksSDCA5WayListName,
                            filters: {
                                _x0035_Way: (deviationCardsIds.length > 0 &&
                                    deviationCardsIds) || [0],
                            },
                            method: '/api/sdca5-way/search'
                        }),
                    ]).then((values: any) => {
                        let arrRequests: any = [];
                        let sdcaItemsAll: any = {
                            deviationCards: [],
                        };
                        values.map((results: any, idx: number) => {
                            sdcaItemsAll["deviationCards"] = [...results.items];
                            const sdcaItems = [...results.items];
                            sdcaItems.map((item) => {
                                arrRequests = [
                                    ...arrRequests,
                                    getItemsRequest({
                                        listName: myTaskActionsListName,
                                        filters: {
                                            ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
                                        },
                                    }),
                                ];
                            });
                        });
                        Promise.all(arrRequests).then((values) => {
                            let actions: any = [];
                            values.map((value) => {
                                actions = [...actions, ...value.items];
                            });
                            const returnItemsDeviationCards = cards5Way
                                .filter(
                                    (card5Way: any) => card5Way.Type5Way === "DeviationReport"
                                )
                                .map((item: any) => {
                                    const currentSdcaItems = sdcaItemsAll[
                                        "deviationCards"
                                    ].filter(
                                        (sdcaItem: any) =>
                                            sdcaItem._x0035_Way && sdcaItem._x0035_Way.get_lookupId() === item.ID
                                    );
                                    let currentActions: any = [];
                                    currentSdcaItems.map((currentSdcaItem: any) => {
                                        currentActions = [
                                            ...currentActions,
                                            ...actions.filter(
                                                (action: any) =>
                                                    action.ImportantHashTag.indexOf(
                                                        `#Отчет_об_отклонениях_${currentSdcaItem.ID}`
                                                    ) !== -1
                                            ),
                                        ];
                                    });
                                    return {
                                        ...item,
                                        actions: currentActions,
                                    };
                                });
                            const cards5WayData = [...returnItemsDeviationCards];
                            let actionsIncStatus: any = {
                                name: "В процессе",
                                color: "#F2A900",
                            };
                            let returnItems = items.map((item: any) => {
                                let currentActions: any = [];
                                const card5WayInc =
                                    (cards5WayData.filter(
                                        (card5way: any) =>
                                            card5way.Incident.get_lookupId() === item.ID
                                    ).length > 0 &&
                                        cards5WayData.filter(
                                            (card5way: any) =>
                                                card5way.Incident.get_lookupId() === item.ID
                                        )[0]) ||
                                    null;
                                if (card5WayInc) {
                                    currentActions = [
                                        ...currentActions,
                                        ...card5WayInc["actions"],
                                    ];
                                }
                                if (currentActions.length === 0) {
                                    actionsIncStatus = { name: "Нет действий", color: "#FDE5D8" };
                                } else if (
                                    currentActions.length > 0 &&
                                    currentActions.some(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.old
                                    )
                                ) {
                                    actionsIncStatus = { name: "Просрочено", color: "#F23030" };
                                } else if (
                                    currentActions.length > 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.cancel
                                    ).length === currentActions.length
                                ) {
                                    actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                                } else if (
                                    currentActions.length > 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.closed
                                    ).length === currentActions.length
                                ) {
                                    actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                                } else if (
                                    currentActions.length > 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.notStart
                                    ).length === currentActions.length
                                ) {
                                    actionsIncStatus = { name: "Не начато", color: "#FDE5D8" };
                                } else if (
                                    currentActions.length > 0 &&
                                    (currentActions.some(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.cancel
                                    ) ||
                                        currentActions.some(
                                            (action: any) =>
                                                action.Status.get_lookupId() === actionsStatus.closed
                                        )) &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.old
                                    ).length === 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.process
                                    ).length === 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.notStart
                                    ).length === 0
                                ) {
                                    actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                                } else if (
                                    currentActions.length > 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.old
                                    ).length === 0 &&
                                    currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.process
                                    ).length > 0
                                ) {
                                    actionsIncStatus = { name: "В процессе", color: "#F2A900" };
                                }
                                return {
                                    ...item,
                                    actions: currentActions,
                                    processActionsCount: currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.process
                                    ).length,
                                    overdueActionsCount: currentActions.filter(
                                        (action: any) =>
                                            action.Status.get_lookupId() === actionsStatus.old
                                    ).length,
                                    actionsIncStatus,
                                };
                            });
                            let localTempInc: any = [];
                            localTempInc = [...returnItems];
                            let incWithQuestions: any = [];
                            localTempInc.forEach((incItem: any) => {
                                if (incItem.Questions) {
                                    incWithQuestions = [
                                        ...incWithQuestions,
                                        { ...incItem, ...JSON.parse(incItem.Questions) },
                                    ];
                                }
                            });
                            incWithQuestions = [..._.uniqWith(incWithQuestions, _.isEqual)];
                            const timestamp = moment().unix();
                            if (incWithQuestions.length > 0) {
                                let tableStr = "";
                                tableStr += `<p style="font-weight: bold; padding: 12px;">Ниже информация по инцидентам, зарегистрированным в период с ${formDataSendEmails["DateIncidents"].startDate
                                    } по ${formDataSendEmails["DateIncidents"].endDate
                                    } г:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">ID</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Дата регистрации</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Отдел</th>
                        ${((idCurrentTypeInc === incTypes.safe ||
                                        idCurrentTypeInc === incTypes.e) &&
                                        `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Классификация инцидента</th>`) ||
                                    ""
                                    }
                        ${(idCurrentTypeInc === incTypes.safe &&
                                        `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Тип SIF</th>`) ||
                                    ""
                                    }
                        ${(idCurrentTypeInc === incTypes.m &&
                                        `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Участок</th><th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Название оборудования</th>`) ||
                                    ""
                                    }
                        ${(idCurrentTypeInc === incTypes.q &&
                                        `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Инцидент в процессе/ по качеству</th>`) ||
                                    ""
                                    }
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Описание</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Статус инцидента</th>
                    </tr>
                </thead><tbody>`;
                                incWithQuestions
                                    .filter(
                                        (item: any) =>
                                            moment(item.DateIncidents).unix() >
                                            localIncDateEmails.start &&
                                            moment(item.DateIncidents).unix() < localIncDateEmails.end
                                    )
                                    .forEach((inc: any) => {
                                        tableStr += `<tr>
                    <td style="background-color: #00629B; color: white; font-weight: bold; padding: 10px; border: 1px solid #ddd;">
                        <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${inc.ID
                                            }&removeMail=${timestamp}" style="color: white; text-decoration: underline;">${inc.ID
                                            }</a>
                    </td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${moment(
                                                inc.DateIncidents
                                            ).format("DD.MM.YYYY")}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Location.get_lookupValue()}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Department.get_lookupValue()}</td>
                    ${((idCurrentTypeInc === incTypes.safe ||
                                                idCurrentTypeInc === incTypes.e) &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${(idCurrentTypeInc === incTypes.e &&
                                                    inc.EnvIncClassification.name) ||
                                                inc.SafeIncClassification.name
                                                }</td>`) ||
                                            ""
                                            }
                    ${(idCurrentTypeInc === incTypes.safe &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${inc[
                                                Object.keys(inc)
                                                    .map((key) => key)
                                                    .filter(
                                                        (key) => key.indexOf("SafeIncTypeSIF") !== -1
                                                    )[0]
                                                ]
                                                }</td>`) ||
                                            ""
                                            }
                     ${(idCurrentTypeInc === incTypes.m &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${inc.Region.get_lookupValue()}</td><td style="padding: 10px; border: 1px solid #ddd;">${inc.MIncEq[0]["SAP"]["Title"]
                                                }</td>`) ||
                                            ""
                                            }
                        ${(idCurrentTypeInc === incTypes.q &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${inc["QAIncidentType"]}</td>`) ||
                                            ""
                                            }
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Description
                                            }</td>
                    <td style="padding: 10px; border: 1px solid #ddd; background-color: ${(isStrapi && inc.Status.get_metadata().Color) ||
                                            inc.Status_x003a_Color.get_lookupValue()
                                            }; text-align: center;">${inc.Status.get_lookupValue()}</td>
                </tr>`;
                                    });
                                tableStr += `</tbody></table>`;
                                tableStr += `<br/>`;
                                if (idCurrentTypeInc === incTypes.m) {
                                    let incWithQuestionsMonth: any = incWithQuestions.filter(
                                        (item: any) =>
                                            moment(item.DateIncidents).unix() >
                                            localIncDateEmails.endDate.startOf("M").unix() &&
                                            moment(item.DateIncidents).unix() <
                                            localIncDateEmails.endDate.endOf("M").unix()
                                    );
                                    let departmentsMonth = [
                                        ..._.uniqWith(
                                            incWithQuestionsMonth.map((item: any) =>
                                                item.Department.get_lookupValue()
                                            ),
                                            _.isEqual
                                        ),
                                    ];
                                    let locatioinsMonth = [
                                        ..._.uniqWith(
                                            incWithQuestionsMonth.map((item: any) =>
                                                item.Location.get_lookupValue()
                                            ),
                                            _.isEqual
                                        ),
                                    ];
                                    tableStr += `<p style="font-weight: bold; padding: 12px;">MTD ${localIncDateEmails.endDate.format(
                                        "MMMM YYYY"
                                    )}:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                                    departmentsMonth.forEach((department: any, idx: number) => {
                                        if (idx <= 3) {
                                            tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${department}</th>`;
                                        }
                                    });
                                    if (departmentsMonth.length > 4) {
                                        tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">...</th>`;
                                    }
                                    tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                                    tableStr += `</tr></thead><tbody>`;
                                    locatioinsMonth.forEach((location: any) => {
                                        tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>
                                        ${(departmentsMonth.length >= 1 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsMonth[0]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsMonth.length >= 2 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsMonth[1]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsMonth.length >= 3 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsMonth[2]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsMonth.length === 4 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsMonth[3]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsMonth.length > 4 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsMonth[3] &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsMonth[2] &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsMonth[1] &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsMonth[0]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${`<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                (inc: any) =>
                                                    inc.Location.get_lookupValue() ===
                                                    location
                                            ).length
                                            }</td></tr>`}
                                        `;
                                    });
                                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>${(departmentsMonth.length >= 1 &&
                                        `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                            (inc: any) =>
                                                inc.Department.get_lookupValue() ===
                                                departmentsMonth[0]
                                        ).length
                                        }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsMonth.length >= 2 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() ===
                                                    departmentsMonth[1]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsMonth.length >= 3 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() ===
                                                    departmentsMonth[2]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsMonth.length === 4 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() ===
                                                    departmentsMonth[3]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsMonth.length > 4 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsMonth[3] &&
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsMonth[2] &&
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsMonth[1] &&
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsMonth[0]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.length
                                        }</td></tr>`;
                                    tableStr += `</tbody></table>`;
                                    tableStr += `<br/>`;

                                    let incWithQuestionsYear: any = incWithQuestions.filter(
                                        (item: any) =>
                                            moment(item.DateIncidents).unix() >
                                            localIncDateEmails.endDate.startOf("year").unix() &&
                                            moment(item.DateIncidents).unix() <
                                            localIncDateEmails.endDate.endOf("year").unix()
                                    );
                                    let departmentsYear = [
                                        ..._.uniqWith(
                                            incWithQuestionsYear.map((item: any) =>
                                                item.Department.get_lookupValue()
                                            ),
                                            _.isEqual
                                        ),
                                    ];
                                    let locatioinsYear = [
                                        ..._.uniqWith(
                                            incWithQuestionsYear.map((item: any) =>
                                                item.Location.get_lookupValue()
                                            ),
                                            _.isEqual
                                        ),
                                    ];
                                    tableStr += `<p style="font-weight: bold; padding: 12px;">YTD ${localIncDateEmails.endDate.format(
                                        "YYYY"
                                    )}:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                                    departmentsYear.forEach((department: any, idx: number) => {
                                        if (idx <= 3) {
                                            tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${department}</th>`;
                                        }
                                    });
                                    if (departmentsYear.length > 4) {
                                        tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">...</th>`;
                                    }
                                    tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                                    tableStr += `</tr></thead><tbody>`;
                                    locatioinsYear.forEach((location: any) => {
                                        tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>
                                        ${(departmentsYear.length >= 1 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsYear[0]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsYear.length >= 2 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsYear[1]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsYear.length >= 3 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsYear[2]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsYear.length === 4 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() ===
                                                        departmentsYear[3]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${(departmentsYear.length > 4 &&
                                                `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() ===
                                                        location &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsYear[3] &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsYear[2] &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsYear[1] &&
                                                        inc.Department.get_lookupValue() !==
                                                        departmentsYear[0]
                                                ).length
                                                }</td>`) ||
                                            ""
                                            }
                                        ${`<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                                                (inc: any) =>
                                                    inc.Location.get_lookupValue() ===
                                                    location
                                            ).length
                                            }</td></tr>`}
                                        `;
                                    });
                                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>${(departmentsYear.length >= 1 &&
                                        `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                                            (inc: any) =>
                                                inc.Department.get_lookupValue() ===
                                                departmentsYear[0]
                                        ).length
                                        }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsYear.length >= 2 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() ===
                                                    departmentsYear[1]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsYear.length >= 3 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() ===
                                                    departmentsYear[2]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsYear.length === 4 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() ===
                                                    departmentsYear[3]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }
                                    ${(departmentsYear.length > 4 &&
                                            `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                                                (inc: any) =>
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsYear[3] &&
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsYear[2] &&
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsYear[1] &&
                                                    inc.Department.get_lookupValue() !==
                                                    departmentsYear[0]
                                            ).length
                                            }</td>`) ||
                                        ""
                                        }<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.length
                                        }</td></tr>`;
                                    tableStr += `</tbody></table>`;
                                    tableStr += `<br/>`;

                                    tableStr += `<p style="font-weight: bold; padding: 12px;">В настоящий момент в системе Мои Задачи <span style="text-decoration: underline">отсутствуют расследования (весь период)</span></p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">ID</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Дата регистрации</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>
                    </tr>
                </thead><tbody>`;
                                    incWithQuestions
                                        .filter(
                                            (inc: any) =>
                                                inc.Status.get_lookupId() !== incStatus.finish &&
                                                inc.Status.get_lookupId() !== incStatus.cancel
                                        )
                                        .forEach((inc: any) => {
                                            tableStr += `<tr>
                    <td style="background-color: #00629B; color: white; font-weight: bold; padding: 10px; border: 1px solid #ddd;">
                        <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${inc.ID
                                                }&removeMail=${timestamp}" style="color: white; text-decoration: underline;">${inc.ID
                                                }</a>
                    </td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${moment(
                                                    inc.DateIncidents
                                                ).format("DD.MM.YYYY")}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Location.get_lookupValue()}</td>
                </tr>`;
                                        });
                                    tableStr += `</tbody></table>`;
                                    tableStr += `<br/>`;

                                    let locatioinsActions = [
                                        ..._.uniqWith(
                                            incWithQuestions.map((item: any) =>
                                                item.Location.get_lookupValue()
                                            ),
                                            _.isEqual
                                        ),
                                    ];
                                    let locationsActionsObj: any = {};
                                    locatioinsActions.forEach((loc: any) => {
                                        locationsActionsObj[loc] = {
                                            process: incWithQuestions
                                                .map(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() === loc &&
                                                        inc.processActionsCount
                                                )
                                                .reduce(
                                                    (accumulator: number, currentValue: number) =>
                                                        accumulator + currentValue,
                                                    0
                                                ),
                                            overdue: incWithQuestions
                                                .map(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() === loc &&
                                                        inc.overdueActionsCount
                                                )
                                                .reduce(
                                                    (accumulator: number, currentValue: number) =>
                                                        accumulator + currentValue,
                                                    0
                                                ),
                                        };
                                    });
                                    tableStr += `<p style="font-weight: bold; padding: 12px;">Незакрытые действия (весь период)</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th><th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">В процессе</th><th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Просрочено</th>`;
                                    tableStr += `</tr></thead><tbody>`;
                                    locatioinsActions.forEach((location: any) => {
                                        tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td><td style="padding: 10px; border: 1px solid #ddd;">${locationsActionsObj[location]["process"]}</td><td style="padding: 10px; border: 1px solid #ddd;">${locationsActionsObj[location]["overdue"]}</td></tr>`;
                                    });
                                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestions
                                        .map((inc: any) => inc.processActionsCount)
                                        .reduce(
                                            (accumulator: number, currentValue: number) =>
                                                accumulator + currentValue,
                                            0
                                        )}</td><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestions
                                            .map((inc: any) => inc.overdueActionsCount)
                                            .reduce(
                                                (accumulator: number, currentValue: number) =>
                                                    accumulator + currentValue,
                                                0
                                            )}</td></tr>`;
                                    tableStr += `</tbody></table>`;
                                    tableStr += `<br/>`;
                                    const elem: any = document.querySelector("#tempScreen");
                                    setTempScreenData(locationsActionsObj);
                                    setTempScrenLabels([
                                        {
                                            label: "В процессе",
                                            color: "#F2A900",
                                            type: "process",
                                        },
                                        {
                                            label: "Просрочено",
                                            color: "#BA0C2F",
                                            type: "overdue",
                                        },
                                    ]);
                                    elem.style.display = "flex";
                                    setTimeout(() => {
                                        html2canvas(elem, {
                                            useCORS: true,
                                            allowTaint: true,
                                        }).then(function (canvas) {
                                            elem.style.display = "none";
                                            const urlScreen = canvas.toDataURL();
                                            tableStr += `<img src="${urlScreen}" alt=""><br/>`;
                                            getItemsRequest({
                                                listName: myTasksIncidentsRecipientsListListName,
                                                filters: {
                                                    Title: `${formDataSendEmails["TypeIncident"]}*`,
                                                },
                                                sortOrder: { name: "ID", desc: true },
                                            }).then((results) => {
                                                const emails = results.items[0]["Emails"] || "";
                                                const copies = results.items[0]["Copies"] || "";
                                                // if (emailsSender && formDataSendEmails.Msg === "Нет") {
                                                //     const emailBody = {
                                                //         Body: tableStr,
                                                //         DateToBeSentAt: moment()
                                                //             .subtract(12, "hours")
                                                //             .toDate(),
                                                //         Title: "Мои Задачи | Отчет по инцидентам",
                                                //         Subject: "Мои Задачи | Отчет по инцидентам",
                                                //         Recepients: emails,
                                                //         CC: copies,
                                                //         CheckDoc: String(timestamp),
                                                //     };
                                                //     Promise.all([sendEmail(emailBody)]).then(() => {
                                                //         setLoadingSetEmail(false);
                                                //         setOpenSendReportModal(!openSendReportModal);
                                                //         setFormDataSetEmails(null);
                                                //         navigate('/dashboard/3/reports');
                                                //     });
                                                // } else {

                                                // }
                                                const downloadOutlookFile = async () => {
                                                    try {
                                                        await downloadOutlookEmailWithAttachments({
                                                            from: {
                                                                name: currentUser.displayName,
                                                                email: currentUser.email,
                                                            },
                                                            to:
                                                                (emails &&
                                                                    emails.split(",").map((email: string) => {
                                                                        return {
                                                                            name: email.trim(),
                                                                            email: email.trim(),
                                                                        };
                                                                    })) ||
                                                                [],
                                                            cc:
                                                                (copies &&
                                                                    copies.split(",").map((email: string) => {
                                                                        return {
                                                                            name: email.trim(),
                                                                            email: email.trim(),
                                                                        };
                                                                    })) ||
                                                                [],
                                                            subject: "Отчет по инцидентам",
                                                            htmlBody: tableStr,
                                                            textBody: "",
                                                            attachments: [],
                                                            fileName: "reports_inc.eml",
                                                        });
                                                    } catch (error) {
                                                        console.error("Ошибка:", error);
                                                    }
                                                };
                                                downloadOutlookFile().then(() => {
                                                    setLoadingSetEmail(false);
                                                    setOpenSendReportModal(!openSendReportModal);
                                                    setFormDataSetEmails(null);
                                                    navigate('/dashboard/3/reports');
                                                });
                                            });
                                        });
                                    }, 3000);
                                }
                                if (idCurrentTypeInc === incTypes.q) {
                                    let incWithQuestionsPeriod: any = incWithQuestions.filter(
                                        (item: any) =>
                                            moment(item.DateIncidents).unix() >
                                            localIncDateEmails.start &&
                                            moment(item.DateIncidents).unix() < localIncDateEmails.end
                                    );
                                    let categoryPeriodProcces = incWithQuestionsPeriod.map(
                                        (item: any) =>
                                            item.QAProcessIncidentCategory &&
                                            item.QAProcessIncidentCategory.name
                                    );
                                    let categoryPeriodQA = incWithQuestionsPeriod.map(
                                        (item: any) =>
                                            item.QAIncidentCategory && item.QAIncidentCategory.name
                                    );
                                    let locatioinsPeriod = [
                                        ..._.uniqWith(
                                            incWithQuestionsPeriod.map((item: any) =>
                                                item.Location.get_lookupValue()
                                            ),
                                            _.isEqual
                                        ),
                                    ];
                                    let categoryPeriod = [
                                        ..._.uniqWith(
                                            [...categoryPeriodProcces, ...categoryPeriodQA],
                                            _.isEqual
                                        ),
                                    ].filter((element) => element !== undefined);

                                    tableStr += `<p style="font-weight: bold; padding: 12px; text-decoration: underline;">Статистика по заводам с ${formDataSendEmails["DateIncidents"].startDate} по ${formDataSendEmails["DateIncidents"].endDate} (*Категория инцидента):</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                                    categoryPeriod.forEach((category: any) => {
                                        tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${category}</th>`;
                                    });
                                    tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                                    tableStr += `</tr></thead><tbody>`;
                                    locatioinsPeriod.forEach((location: any) => {
                                        tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>`;
                                        categoryPeriod.forEach((category) => {
                                            tableStr += `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsPeriod.filter(
                                                (inc: any) =>
                                                    inc.Location.get_lookupValue() === location &&
                                                    ((inc.QAProcessIncidentCategory &&
                                                        inc.QAProcessIncidentCategory["name"] ===
                                                        category) ||
                                                        (inc.QAIncidentCategory &&
                                                            inc.QAIncidentCategory["name"] === category))
                                            ).length
                                                }</td>`;
                                        });
                                        tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsPeriod.filter(
                                            (inc: any) =>
                                                inc.Location.get_lookupValue() === location
                                        ).length
                                            }</td></tr>`;
                                    });
                                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>`;
                                    categoryPeriod.forEach((category) => {
                                        tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsPeriod.filter(
                                            (inc: any) =>
                                                (inc.QAProcessIncidentCategory &&
                                                    inc.QAProcessIncidentCategory.name === category) ||
                                                (inc.QAIncidentCategory &&
                                                    inc.QAIncidentCategory.name === category)
                                        ).length
                                            }</td>`;
                                    });
                                    tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsPeriod.length}</td></tr>`;
                                    tableStr += `</tbody></table>`;
                                    tableStr += `<br/>`;

                                    let locationsPeriodObj: any = {};
                                    locatioinsPeriod.forEach((loc: any) => {
                                        categoryPeriod.forEach((category: any) => {
                                            locationsPeriodObj[loc] = {
                                                ...locationsPeriodObj[loc],
                                                [category]: incWithQuestionsPeriod.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() === loc &&
                                                        ((inc.QAProcessIncidentCategory &&
                                                            inc.QAProcessIncidentCategory["name"] ===
                                                            category) ||
                                                            (inc.QAIncidentCategory &&
                                                                inc.QAIncidentCategory["name"] === category))
                                                ).length,
                                            };
                                        });
                                    });
                                    setTempScreenData(locationsPeriodObj);
                                    let tempLabels: any = [];
                                    categoryPeriod.forEach((category) => {
                                        tempLabels = [
                                            ...tempLabels,
                                            {
                                                label: category,
                                                color: getRandomColor(),
                                                type: category,
                                            },
                                        ];
                                    });
                                    setTempScrenLabels([...tempLabels]);
                                    const elem: any = document.querySelector("#tempScreen");
                                    elem.style.display = "flex";
                                    setTimeout(() => {
                                        html2canvas(elem, {
                                            useCORS: true,
                                            allowTaint: true,
                                        }).then(function (canvas) {
                                            elem.style.display = "none";
                                            const urlScreen = canvas.toDataURL();
                                            tableStr += `<img src="${urlScreen}" alt=""><br/>`;
                                            setTempScreenData({});
                                            setTempScrenLabels([]);

                                            let incWithQuestionsMonth: any = incWithQuestions.filter(
                                                (item: any) =>
                                                    moment(item.DateIncidents).unix() >
                                                    localIncDateEmails.endDate.startOf("M").unix() &&
                                                    moment(item.DateIncidents).unix() <
                                                    localIncDateEmails.endDate.endOf("M").unix()
                                            );
                                            let categoryMonthProcces = incWithQuestionsMonth.map(
                                                (item: any) =>
                                                    item.QAProcessIncidentCategory &&
                                                    item.QAProcessIncidentCategory.name
                                            );
                                            let categoryMonthQA = incWithQuestionsMonth.map(
                                                (item: any) =>
                                                    item.QAIncidentCategory &&
                                                    item.QAIncidentCategory.name
                                            );
                                            let locatioinsMonth = [
                                                ..._.uniqWith(
                                                    incWithQuestionsMonth.map((item: any) =>
                                                        item.Location.get_lookupValue()
                                                    ),
                                                    _.isEqual
                                                ),
                                            ];
                                            let categoryMonth = [
                                                ..._.uniqWith(
                                                    [...categoryMonthProcces, ...categoryMonthQA],
                                                    _.isEqual
                                                ),
                                            ].filter((element) => element !== undefined);

                                            tableStr += `<p style="font-weight: bold; padding: 12px; text-decoration: underline;">MTD ${localIncDateEmails.endDate.format(
                                                "MMMM YYYY"
                                            )}:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                                            categoryMonth.forEach((category: any) => {
                                                tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${category}</th>`;
                                            });
                                            tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                                            tableStr += `</tr></thead><tbody>`;
                                            locatioinsMonth.forEach((location: any) => {
                                                tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>`;
                                                categoryMonth.forEach((category) => {
                                                    tableStr += `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                                                        (inc: any) =>
                                                            inc.Location.get_lookupValue() === location &&
                                                            ((inc.QAProcessIncidentCategory &&
                                                                inc.QAProcessIncidentCategory["name"] ===
                                                                category) ||
                                                                (inc.QAIncidentCategory &&
                                                                    inc.QAIncidentCategory["name"] ===
                                                                    category))
                                                    ).length
                                                        }</td>`;
                                                });
                                                tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        inc.Location.get_lookupValue() === location
                                                ).length
                                                    }</td></tr>`;
                                            });
                                            tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>`;
                                            categoryMonth.forEach((category) => {
                                                tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                                                    (inc: any) =>
                                                        (inc.QAProcessIncidentCategory &&
                                                            inc.QAProcessIncidentCategory.name ===
                                                            category) ||
                                                        (inc.QAIncidentCategory &&
                                                            inc.QAIncidentCategory.name === category)
                                                ).length
                                                    }</td>`;
                                            });
                                            tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.length}</td></tr>`;
                                            tableStr += `</tbody></table>`;
                                            tableStr += `<br/>`;

                                            let locationsMonthObj: any = {};
                                            locatioinsMonth.forEach((loc: any) => {
                                                categoryMonth.forEach((category: any) => {
                                                    locationsMonthObj[loc] = {
                                                        ...locationsMonthObj[loc],
                                                        [category]: incWithQuestionsMonth.filter(
                                                            (inc: any) =>
                                                                inc.Location.get_lookupValue() === loc &&
                                                                ((inc.QAProcessIncidentCategory &&
                                                                    inc.QAProcessIncidentCategory["name"] ===
                                                                    category) ||
                                                                    (inc.QAIncidentCategory &&
                                                                        inc.QAIncidentCategory["name"] ===
                                                                        category))
                                                        ).length,
                                                    };
                                                });
                                            });
                                            setTempScreenData(locationsMonthObj);
                                            let tempLabels: any = [];
                                            categoryMonth.forEach((category) => {
                                                tempLabels = [
                                                    ...tempLabels,
                                                    {
                                                        label: category,
                                                        color: getRandomColor(),
                                                        type: category,
                                                    },
                                                ];
                                            });
                                            setTempScrenLabels([...tempLabels]);
                                            elem.style.display = "flex";
                                            setTimeout(() => {
                                                html2canvas(elem, {
                                                    useCORS: true,
                                                    allowTaint: true,
                                                }).then(function (canvas) {
                                                    elem.style.display = "none";
                                                    const urlScreen = canvas.toDataURL();
                                                    tableStr += `<img src="${urlScreen}" alt=""><br/>`;
                                                    tableStr += `<p style="font-weight: bold; padding: 12px;">В настоящий момент в системе Мои Задачи <span style="text-decoration: underline">отсутствуют расследования (весь период)</span></p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">ID</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Дата регистрации</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>
                    </tr>
                </thead><tbody>`;
                                                    incWithQuestions
                                                        .filter(
                                                            (inc: any) =>
                                                                inc.Status.get_lookupId() !==
                                                                incStatus.finish &&
                                                                inc.Status.get_lookupId() !== incStatus.cancel
                                                        )
                                                        .forEach((inc: any) => {
                                                            tableStr += `<tr>
                    <td style="background-color: #00629B; color: white; font-weight: bold; padding: 10px; border: 1px solid #ddd;">
                        <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${inc.ID
                                                                }&removeMail=${timestamp}" style="color: white; text-decoration: underline;">${inc.ID
                                                                }</a>
                    </td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${moment(
                                                                    inc.DateIncidents
                                                                ).format("DD.MM.YYYY")}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Location.get_lookupValue()}</td>
                </tr>`;
                                                        });
                                                    tableStr += `</tbody></table>`;
                                                    tableStr += `<br/>`;
                                                    setTempScreenData({});
                                                    setTempScrenLabels([]);
                                                    getItemsRequest({
                                                        listName: myTasksIncidentsRecipientsListListName,
                                                        filters: {
                                                            Title: `${formDataSendEmails["TypeIncident"]}*`,
                                                        },
                                                        sortOrder: { name: "ID", desc: true },
                                                    }).then((results) => {
                                                        const emails = results.items[0]["Emails"] || "";
                                                        const copies = results.items[0]["Copies"] || "";
                                                        if (
                                                            emailsSender &&
                                                            formDataSendEmails.Msg === "Нет"
                                                        ) {
                                                            const emailBody = {
                                                                Body: tableStr,
                                                                DateToBeSentAt: moment()
                                                                    .subtract(12, "hours")
                                                                    .toDate(),
                                                                Title: "Мои Задачи | Отчет по инцидентам",
                                                                Subject: "Мои Задачи | Отчет по инцидентам",
                                                                Recepients: emails,
                                                                CC: copies,
                                                                CheckDoc: String(timestamp),
                                                            };
                                                            Promise.all([sendEmail(emailBody)]).then(() => {
                                                                setLoadingSetEmail(false);
                                                                setOpenSendReportModal(!openSendReportModal);
                                                                setFormDataSetEmails(null);
                                                                navigate('/dashboard/3/reports');
                                                            });
                                                        } else {
                                                            const downloadOutlookFile = async () => {
                                                                try {
                                                                    await downloadOutlookEmailWithAttachments({
                                                                        from: {
                                                                            name: currentUser.displayName,
                                                                            email: currentUser.email,
                                                                        },
                                                                        to:
                                                                            (emails &&
                                                                                emails
                                                                                    .split(",")
                                                                                    .map((email: string) => {
                                                                                        return {
                                                                                            name: email.trim(),
                                                                                            email: email.trim(),
                                                                                        };
                                                                                    })) ||
                                                                            [],
                                                                        cc:
                                                                            (copies &&
                                                                                copies
                                                                                    .split(",")
                                                                                    .map((email: string) => {
                                                                                        return {
                                                                                            name: email.trim(),
                                                                                            email: email.trim(),
                                                                                        };
                                                                                    })) ||
                                                                            [],
                                                                        subject: "Отчет по инцидентам",
                                                                        htmlBody: tableStr,
                                                                        textBody: "",
                                                                        attachments: [],
                                                                        fileName: "reports_inc.eml",
                                                                    });
                                                                } catch (error) {
                                                                    console.error("Ошибка:", error);
                                                                }
                                                            };
                                                            downloadOutlookFile().then(() => {
                                                                setLoadingSetEmail(false);
                                                                setOpenSendReportModal(!openSendReportModal);
                                                                setFormDataSetEmails(null);
                                                                navigate('/dashboard/3/reports');
                                                            });
                                                        }
                                                    });
                                                });
                                            }, 3000);
                                        });
                                    }, 3000);
                                }
                                if (
                                    idCurrentTypeInc !== incTypes.m &&
                                    idCurrentTypeInc !== incTypes.q
                                ) {
                                    getItemsRequest({
                                        listName: myTasksIncidentsRecipientsListListName,
                                        filters: {
                                            Title: `${formDataSendEmails["TypeIncident"]}*`,
                                        },
                                        sortOrder: { name: "ID", desc: true },
                                    }).then(async (results) => {
                                        const emails = results.items[0]["Emails"] || "";
                                        const copies = results.items[0]["Copies"] || "";
                                        // if (emailsSender && formDataSendEmails.Msg === "Нет") {
                                        //     const emailBody = {
                                        //         Body: tableStr,
                                        //         DateToBeSentAt: moment().subtract(12, "hours").toDate(),
                                        //         Title: "Мои Задачи | Отчет по инцидентам",
                                        //         Subject: "Мои Задачи | Отчет по инцидентам",
                                        //         Recepients: emails,
                                        //         CC: copies,
                                        //         CheckDoc: String(timestamp),
                                        //     };
                                        //     Promise.all([sendEmail(emailBody)]).then(() => {
                                        //         setLoadingSetEmail(false);
                                        //         setOpenSendReportModal(!openSendReportModal);
                                        //         setFormDataSetEmails(null);
                                        //         navigate('/dashboard/3/reports');
                                        //     });
                                        // } else {

                                        // }
                                        const downloadOutlookFile = async () => {
                                            try {
                                                await downloadOutlookEmailWithAttachments({
                                                    from: {
                                                        name: currentUser.displayName,
                                                        email: currentUser.email,
                                                    },
                                                    to:
                                                        (emails &&
                                                            emails.split(",").map((email: string) => {
                                                                return {
                                                                    name: email.trim(),
                                                                    email: email.trim(),
                                                                };
                                                            })) ||
                                                        [],
                                                    cc:
                                                        (copies &&
                                                            copies.split(",").map((email: string) => {
                                                                return {
                                                                    name: email.trim(),
                                                                    email: email.trim(),
                                                                };
                                                            })) ||
                                                        [],
                                                    subject: "Отчет по инцидентам",
                                                    htmlBody: tableStr,
                                                    textBody: "",
                                                    attachments: [],
                                                    fileName: "reports_inc.eml",
                                                });
                                            } catch (error) {
                                                console.error("Ошибка:", error);
                                            }
                                        };
                                        downloadOutlookFile().then(() => {
                                            setLoadingSetEmail(false);
                                            setOpenSendReportModal(!openSendReportModal);
                                            setFormDataSetEmails(null);
                                            navigate('/dashboard/3/reports');
                                        });
                                    });
                                }
                            } else {
                                setLoadingSetEmail(false);
                                setOpenSendReportModal(!openSendReportModal);
                                setFormDataSetEmails(null);
                                navigate('/dashboard/3/reports');
                            }
                        });
                    });
                });
            });
        }
    }, [formDataSendEmails]);

    useEffect(() => {
        if (location.pathname.indexOf('/dashboard/3/reports/6') !== -1 && !openSendReportModal) {
            navigate('/dashboard/3/reports');
        }
    }, [location, openSendReportModal]);

    return (
        <Modal
            zIndex={70}
            open={openSendReportModal}
            toggleDialog={(state) => setOpenSendReportModal(state)}
            modalClassName="min-h-0 flex"
            hideXMarkIcon={loadingSendEmail && true || false}
        >
            {(!loadingSendEmail && (
                <>
                    <header className="px-10">
                        <h2>Отчет по инцидентам</h2>
                    </header>
                    <FlexCol className="flex-1 px-10 py-5 space-y-4">
                        <Form
                            type="report_my_tasks_inc_send_emails"
                            setFormData={setFormDataSetEmails}
                            fieldsForm={[...fieldsSendEmails]}
                            defaultValues={null}
                            openCancelAddCard={openSendReportModal}
                            setOpenCancelAddCard={setOpenSendReportModal}
                        />
                    </FlexCol>
                </>
            )) || (
                    <>
                        <FlexCol className="items-center justify-center w-full">
                            <span className="block mb-5 text-base text-darkblue">
                                Формируем данные...
                            </span>
                            <Loading />
                        </FlexCol>
                        <br />
                        <FlexCol
                            className="w-full"
                            id="tempScreen"
                            style={{ display: "none" }}
                        >
                            <ChartLicense
                                data={tempScreenData}
                                labels={tempScrenLabels}
                                reportInc={true}
                            />
                        </FlexCol>
                    </>
                )}
        </Modal>
    );
}
